export default __webpack_public_path__ + "static/media/breakfast_8.c742165f.jpg";